/**
 * RouteLoader - Loading fallback for lazy-loaded routes
 * 
 * Displays a centered spinner while route components are loading.
 * Used as the fallback for React.Suspense in route definitions.
 */

export function RouteLoader() {
  return (
    <div className="flex items-center justify-center min-h-[400px] page-enter">
      <div className="text-center">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground text-sm">Loading...</p>
      </div>
    </div>
  );
}

/**
 * PageWrapper - Wrapper for page content with entry animation
 * Use this to wrap page content for smooth transitions
 */
export function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="page-enter">
      {children}
    </div>
  );
}
